import { render, staticRenderFns } from "./VineyardsComponent.vue?vue&type=template&id=0877b976&scoped=true"
import script from "./VineyardsComponent.vue?vue&type=script&lang=js"
export * from "./VineyardsComponent.vue?vue&type=script&lang=js"
import style0 from "./VineyardsComponent.vue?vue&type=style&index=0&id=0877b976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0877b976",
  null
  
)

export default component.exports